import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=df0686fe"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports